import React from 'react';

const SignIn = React.lazy(() => import('./Cospharm.vn/Authentication/SignIn/SignIn'));

const route = [
    { path: '/auth/sign-in', exact: true, name: 'SignIn', component: SignIn }
];

export default route;
